import Body from "./Body";
import Button from "./Button";

export default {
  Body,
  Button
};
